import React from 'react';
import { Link } from 'react-router-dom';
import ScrollToTop from '../components/ScrollToTop';
import '../styles/BlogsPage.css';

export default function DisclaimerPage() {
  return (
    <div className="blogs-page">
      {/* Navbar */}
      <nav className="navbar navbar-expand-lg blogs-navbar">
        <div className="container">
          <Link className="navbar-brand" to="/">
            <img src="/images/sidebar-logo.png" alt="MeetingPoint Logo" loading="lazy" />
          </Link>
          <div className="d-flex align-items-center gap-3">
            <Link to="/blogs" className="btn btn-outline-light btn-sm rounded-pill px-3">
              <i className="fas fa-newspaper me-2"></i>Blog
            </Link>
            <Link to="/" className="btn btn-outline-light btn-sm rounded-pill px-3">
              <i className="fas fa-arrow-left me-2"></i>Home
            </Link>
          </div>
        </div>
      </nav>

      {/* Header */}
      <header className="blog-detail-hero">
        <div className="container">
          <h1 className="blog-detail-title">Disclaimer</h1>
          <p className="blog-detail-excerpt">Last Updated: {new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}</p>
        </div>
      </header>

      {/* Content */}
      <article className="container blog-detail-content">
        <div className="blog-detail-body privacy-body">
          <p>
            MeetingPoint.chat provides a peer-to-peer (P2P) communication platform that enables direct connections between users. Please read this disclaimer carefully before using our service.
          </p>

          <h3>1. No Responsibility for User Conduct</h3>
          <p>MeetingPoint.chat and its operators assume no responsibility or liability for how users utilize this platform. Users are solely responsible for their actions, communications, and behavior while using the service.</p>

          <h3>2. Peer-to-Peer Nature of Service</h3>
          <p>MeetingPoint.chat operates on a decentralized P2P architecture. This means:</p>
          <ul>
            <li><strong>Direct Communication:</strong> All video, voice, chat, and file transfers occur directly between users' browsers, without passing through our servers for content storage or processing.</li>
            <li><strong>No Monitoring:</strong> We do not monitor, record, or have access to the content of user communications.</li>
            <li><strong>No Control:</strong> We have no control over what users choose to share, say, or do during their P2P sessions.</li>
          </ul>

          <h3>3. User Responsibility</h3>
          <p>By using MeetingPoint.chat, you agree to:</p>
          <ul>
            <li>Use the service in compliance with all applicable laws and regulations.</li>
            <li>Take full responsibility for the content you share and the communications you engage in.</li>
            <li>Exercise caution when sharing personal information, as your IP address is visible to the peer you connect with.</li>
            <li>Verify the identity of individuals you connect with, as we provide no identity verification services.</li>
          </ul>

          <h3>4. No Liability for User Actions</h3>
          <p>MeetingPoint.chat shall not be liable for any damages, losses, or harm resulting from:</p>
          <ul>
            <li>The conduct of any user using the platform.</li>
            <li>Any content shared or transmitted during P2P sessions.</li>
            <li>Interactions between users, including but not limited to harassment, fraud, or illegal activities.</li>
            <li>Unauthorized access to your device or data by other users.</li>
          </ul>

          <h3>5. No Endorsement of User Content</h3>
          <p>The views, opinions, and content expressed by users are their own and do not reflect the views of MeetingPoint.chat. We do not endorse, support, or guarantee the accuracy of any user-generated content.</p>

          <h3>6. Technical Limitations</h3>
          <p>As a P2P service, MeetingPoint.chat cannot:</p>
          <ul>
            <li>Prevent users from engaging in inappropriate or illegal activities.</li>
            <li>Block or filter content shared between users.</li>
            <li>Recover lost conversations, files, or connection history.</li>
            <li>Guarantee the security of user devices or networks.</li>
          </ul>

          <h3>7. Indemnification</h3>
          <p>You agree to indemnify and hold harmless MeetingPoint.chat and its operators from any claims, damages, or expenses arising from your use of the service or your violation of these terms.</p>

          <h3>8. Contact</h3>
          <p>If you have questions regarding this disclaimer, please contact us at: <a href="mailto:admin@meetingpoint.chat" className="text-decoration-underline">admin@meetingpoint.chat</a></p>
        </div>
      </article>

      {/* Footer */}
      <footer className="blogs-footer">
        <div className="container text-center">
          <p className="mb-1">&copy; {new Date().getFullYear()} MeetingPoint. All rights reserved.</p>
          <div className="d-flex justify-content-center gap-3 mt-2 flex-wrap">
            <Link to="/" className="text-muted">Home</Link>
            <Link to="/about" className="text-muted">About</Link>
            <Link to="/blogs" className="text-muted">Blog</Link>
            <Link to="/faq" className="text-muted">FAQ</Link>
            <Link to="/contact" className="text-muted">Contact</Link>
            <Link to="/terms" className="text-muted">Terms</Link>
            <Link to="/privacy" className="text-muted">Privacy Policy</Link>
          </div>
        </div>
      </footer>
      <ScrollToTop />
    </div>
  );
}
